// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_SyncResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/accounts/sync/{id}
 *
 * Object-shaped dados from Subaccounts/Franchises::sync(). Two locally-owned
 * scalar flags plus one passthrough provider balance object:
 *   - synced    → always true on the success path (the sync completed)
 *   - balance   → verbatim getBalance() return from the payment provider
 *                 (AsaasProvider::getBalance() returns the raw json_decode of
 *                 the upstream `/finance/balance` response); shape is owned
 *                 downstream by the provider SDK and varies per provider, so
 *                 it is the same shape-erased passthrough as the sibling
 *                 SubaccountsFranchises_BalanceResponse::$dados.
 *   - synced_at → now_gmt3() ISO-ish datetime string stamped at sync time.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsFranchises_SyncResponseDados {
synced: boolean
balance: unknown[]
synced_at: string
}

export type SubaccountsFranchises_SyncResponse = ApiResponse<SubaccountsFranchises_SyncResponseDados>;

registerResponseContract('SubaccountsFranchises_SyncResponse', {
  synced:    { type: 'boolean', required: true },
  balance:   { type: 'array',   required: true },
  synced_at: { type: 'string',  required: true },
})
